import React, { lazy } from 'react';

const GettingStarted = lazy(() => import('./components/GettingStarted'));
const FilerTypes = lazy(() => import('./components/FilerTypes'));
const FilerListing = lazy(() => import('./FilerListing'));
const RecentlyOrganized = lazy(() => import('./components/RecentlyOrganized'));
const BankDepositorySetUp = lazy(() => import('./components/GettingStarted/components/BankDepositorySetUp'));

const routes = [
  {
    path: '/Filers/GettingStarted',
    renderer: (params = {}): JSX.Element => <GettingStarted {...params} />,
  },
  {
    path: '/Home/GettingStarted',
    renderer: (params = {}): JSX.Element => <GettingStarted {...params} />,
  },
  {
    path: '/Filers/FilerTypes',
    renderer: (params = {}): JSX.Element => <FilerTypes {...params} />,
  },
  {
    path: '/FilerListing',
    renderer: (params = {}): JSX.Element => <FilerListing {...params} />,
  },
  {
    path: '/Filers/FilerListing',
    renderer: (params = {}): JSX.Element => <FilerListing {...params} />,
  },
  {
    path: '/Filers/RecentlyOrganized',
    renderer: (params = {}): JSX.Element => <RecentlyOrganized {...params} />,
  },
  {
    path: '/Filers/BankDepository',
    renderer: (params = {}): JSX.Element => <BankDepositorySetUp {...params} />,
  }
];

export default routes;
